import React from 'react'
import Layout from '../../Layout/Layout'
import GIZ from "../../images/giz.PNG"

const GIZ_DTC = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>GIZ/DTC Digital Transformation for women and Youths</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The Digital Skills Training Program for Micro, Small, and Medium 
                        Enterprises (MSMEs) was a key initiative of a partnership between GIZ/DTC Nigeria 
                        (German Development Cooperation/Digital Transformation Center), the European Union,
                         and Moolu Venture Lab. The program was strategically designed to address the 
                         significant digital skills gap among Nigerian MSMEs and accelerate their 
                         successful integration into the digital economy. Been implemented in the
                          Federal Capital Territory (FCT), the program is delivering measurable 
                          impact in enhancing digital competency and catalyzing business transformation. 
</p>

                <p className='light'>Key achievements included participants demonstrating significant
                     improvement in digital literacy and successfully integrating digital solutions to
                      enhance their market reach and revenue generation. 
                    A core focus on gender empowerment was evident, with women comprising 75% of all
                     program participants,thereby providing female entrepreneurs with essential digital
                      skills to effectively compete in Nigeria's evolving digital landscape.
</p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src= {GIZ} />
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default GIZ_DTC